<template>
  <div class="section">
    <div class="box">
      <div class="field">
        <label>Device Name</label>
        <div class="control">
          <input type="text" class="input" v-model="name">
        </div>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button type="button" class="button is-link" @click="submitData()">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fingerprint2 from 'fingerprintjs2'
export default {
  data () {
    return {
      name: '',
      fingerprint: ''
    }
  },
  created () {
    var self = this
    new Fingerprint2().get(function (result, components) {
      self.fingerprint = result
    })
  },
  methods: {
    submitData () {
      var self = this
      self.flyPostSession('device_status/insert_device', {
        name: self.name,
        fingerprint: self.fingerprint
      }).then(function (response) {
        if (response.data.response_code === 1) {
          self.$geb.emit({id: 'alert_modal', title: 'Register Device Success!', content: 'Register Device Success', button_text: 'OK'})
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        console.log(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/RegisterDevice.vue